<template>
  <widget-lcs-root-page class="parse-page" v-if="value" ref="widgetRootId" :key="timer" :value="value"
    :protoInfo="pageInfo" :entryInfo="entryInfo" :pageInstanceId="pageInstanceId" :initData="initData" />
</template>
<script>
import Vue from 'vue'
import { uuid } from '../util/util.js';
import { app, appConfig } from '../config.js';
export default {
  name: "Index",
  provide() {
    return {
      entry: this,
    };
  },
  data() {
    return {
      timer: Date.now(),
      value: null,
      pageInfo: {},
      tableArray: [],
      pageInstanceId: uuid(),
      initData: null,
      subTemplates: {},
      _sysId: '',
      v: ""
    };
  },
  computed: {
    entryInfo() {
      const pageId = this.value ? (this.value.pageId || this.value.components[0].id) : ''
      return {
        sysId: this._sysId || app.sysId || localStorage.getItem('sysCode'),
        openId: '',
        pageId: pageId,
        pageType: '',
        openType: '',
        pageName: '',
        pageParams: {},
        innerParams: {},
        tableArray: this.tableArray,
        subPages: this.subPages || [],
        params: this.params || {}

      }
    },
  },
  methods: {
    getSiteInfo() {
      const { pathname: site } = location
      // const { hash: site } = location
      const ps = (site.split('/') || []).reduce((p, c) => {
        if (c && c != '#') {
          p.push(c.replaceAll('/', ''))
        }
        return p
      }, [])

      return ps
    },
    getParams() {
      let pageUrl = '',
        dataUrl = ''
      const { search } = location
      const ps = this.getSiteInfo()
      pageUrl += `/${ps[0]}`
      dataUrl += `/${ps[0]}`
      if (ps[ps.length - 1].endsWith('.html')) {
        const [t] = ps[ps.length - 1].split('.')
        let s = { page: 1 }
        if (search) {
          s = search.split('?')[1].split('&').reduce((p, c) => {
            const [k, v] = c.split('=')
            p[k] = v
            return p
          }, {})
        }
        pageUrl += `/${t}/listPage.json`
        dataUrl += `/${t}/list_${s.page || 1}.json`
      } else if (ps[ps.length - 1].endsWith('.shtml')) {
        const [uuid] = ps[ps.length - 1].split('.')
        pageUrl += `/${ps[ps.length - 2]}/docPage.json`
        dataUrl += `/${ps[ps.length - 2]}/doc_${uuid}.json`
      } else {
        let column = ps.length > 1 ? `/${ps[ps.length - 1]}` : ''
        pageUrl += `${column}/indexPage.json`
        dataUrl += `${column}/index.json`
      }
      return { pageUrl, dataUrl }
    },
    async loadPage() {
      const { pageUrl, dataUrl } = this.getParams()
      let pageInfo = null, pageData = null
      try {
        pageInfo = await this.$request.request({ url: pageUrl + `?v=${this.v}` })
        pageData = await this.$request.request({ url: dataUrl + `?v=${this.v}` })
      } catch (error) {
        this.value = pageInfo
        this.initData = pageData || {}
      }
      if (!this.value) {
        this.value = pageInfo
      }
      if (!this.initData) {
        this.initData = pageData || {}
      }
      // 后端返回的sysId与config.json中配置的不一致，不使用后端返回的
      // this._sysId = pageInfo.sysId || ''
      if (this.initData.siteName && this.initData.siteName != document.title) {
        document.title = this.initData.siteName
      }
    },
    loadCustomVueComp() {
      const ps = this.getSiteInfo()
      const siteName = ps[0]
      if (!window.customCompList) {
        window.customCompList = []
      }
      this.$request.request({ url: `${siteName}/componentList.json?v=${this.v}` }).then(res => {
        let newCompList = []
        res.forEach(v => {
          let targetComp = window.customCompList.find(u => v.infoId == u.infoId)
          if (!targetComp) {
            newCompList.push(v)
          }
        })
        if (newCompList.length > 0) {
          LowcodeResolver.installCusComps(newCompList, Vue)
        }
        this.loadPage()
      })
    },
    async init() {
      const ps = this.getSiteInfo()
      const siteName = ps[0]
      try {
        const vConfig = await this.$request.request({ url: `/${siteName}/version.json?t=${this.timer}` })
        this.v = vConfig && vConfig.version || ""
      } catch (error) {}
      this.loadCustomVueComp()
    },
  },
  created() {
    this.init()
  },
};
</script>